export default [
  {
    id: 'overview',
    title: 'Що це таке',
    blocks: [
      {
        type: 'text',
        html: `
          <p>Widgets — це банери й оголошення, які студенти бачать у своєму кабінеті:
          смуга з новиною вгорі сторінки, рекламний банер унизу, промо з кнопкою.
          Головне: <b>усе робиться з адмінки за кілька хвилин, без програмістів і без релізів</b>.
          Створили запис, натиснули Active — студенти вже бачать. Вимкнули — зник.</p>
          <p>Один запис = один банер: що показуємо, кому, коли, і чи можна його закрити.</p>
        `
      }
    ]
  },
  {
    id: 'quickstart',
    title: 'Швидкий старт: банер за 5 хвилин',
    blocks: [
      {
        type: 'text',
        html: `
          <p>Розберемо на реальному прикладі — банер
          <b>«Марафон Створення AI-агентів»</b>, який показується студентам конкретного
          курсу і веде на лендинг.</p>
          <ol>
            <li><b>Widgets → + Create.</b></li>
            <li>Заповнюємо основне:<br>
              <span class="field">Name:</span> <code>marathon-1052</code> — службова назва,
              студенти її не бачать; має бути унікальною.<br>
              <span class="field">Type:</span> <code>Footer banner</code> — банер-картинка внизу екрана.<br>
              <span class="field">Link URL:</span>
              <code>https://genius.space/ai-agents/wp/?utm_source=lms&amp;utm_medium=banner</code>
              — куди потрапить студент після кліку (з utm-мітками, щоб маркетинг бачив джерело).<br>
              <span class="field">Courses:</span> обираємо курс «Марафон Створення AI-агентів»
              — банер побачать лише його студенти.<br>
              <span class="field">Status:</span> Active.</li>
            <li><b>Save.</b> Поки що без картинок — це нормально: банер «на паузі»,
              студенти його не бачать, доки картинки не додані.</li>
            <li>Відкриваємо збережений запис ще раз і завантажуємо дві картинки від дизайнера:
              широку для компʼютерів (1600×85) і компактну для телефонів (460×82).</li>
            <li><b>Save.</b> Готово — банер уже у студентів курсу. Жодного деплою.</li>
          </ol>
        `
      },
      {
        type: 'image',
        src: 'https://file.genius.space/uploads/images/setting/widget/cc/6a/ai-agent-desktop.svg',
        alt: 'Банер «Марафон Створення AI-агентів» — реальний кретив 1600×85',
        bg: '#D5F174'
      },
      {
        type: 'text',
        html: `
          <p class="note">Це справжній кретив банера (1600×85), завантажений через цю ж форму. Саме так він виглядає у студента внизу екрана.
          Клік будь-де по банеру відкриває лендинг у новій вкладці.</p>
        `
      }
    ]
  },
  {
    id: 'types',
    title: 'Пʼять типів: який обрати',
    blocks: [
      {
        type: 'card',
        title: 'Footer banner — «є готова картинка від дизайнера»',
        when: 'Обирайте для рекламних кампаній з дизайнерським кретивом.',
        blocks: [
          {
            type: 'text',
            html: `
              <p>Банер-картинка внизу екрана, клікабельний цілком. Ви лише завантажуєте
              два файли і вказуєте посилання. Саме такий — марафонський із прикладу вище.</p>
            `
          }
        ]
      },
      {
        type: 'card',
        title: 'Footer promo — «банер потрібен сьогодні, дизайнера немає»',
        when: 'Обирайте для акцій і закликів до дії без готового кретиву.',
        blocks: [
          {
            type: 'text',
            html: `
              <p>Теж внизу екрана, але текст і кнопку малює сама платформа —
              ви вписуєте слова і кольори. Приклад заповнення:</p>
              <p><span class="field">Text:</span> «Встигни на потік зі знижкою −20%» ·
              <span class="field">Button text:</span> «Забрати знижку» ·
              <span class="field">Link URL:</span> посилання на оплату</p>
            `
          },
          {
            type: 'demo',
            bg: '#E7DFCC',
            color: '#000000',
            text: 'Встигни на потік зі знижкою −20%',
            btnText: 'ЗАБРАТИ ЗНИЖКУ',
            btnBg: '#FF6C39',
            btnColor: '#ffffff'
          }
        ]
      },
      {
        type: 'card',
        title: 'Top bar — «коротке важливе повідомлення»',
        when: 'Обирайте для новин і службових оголошень.',
        blocks: [
          {
            type: 'text',
            html: `
              <p>Тонка смуга над сторінкою: один рядок тексту, за бажанням — посилання.
              Не перекриває контент.</p>
            `
          },
          {
            type: 'demo',
            bg: '#D5F174',
            color: '#000000',
            center: true,
            text: '🛠 21 вересня з 02:00 до 04:00 — технічні роботи, можливі перерви'
          }
        ]
      },
      {
        type: 'card',
        title: 'Generic — «универсальна смуга, вгорі або внизу»',
        when: 'Обирайте, коли жоден з готових не пасує: текст + опційна кнопка, позиція на вибір (top/bottom).',
        blocks: []
      },
      {
        type: 'card',
        title: 'Custom HTML — технічний, не для банерів',
        blocks: [
          {
            type: 'text',
            html: `
              <p>Сирий код у полі Content (чат підтримки, аналітика).
              Для оголошень і банерів <b>не використовуйте</b> — обирайте типи вище.</p>
            `
          }
        ]
      }
    ]
  },
  {
    id: 'colors',
    title: 'Кольори: готові поєднання',
    blocks: [
      {
        type: 'text',
        html: `
          <p>Кольори задаються hex-кодом (шість символів після «#»).
          Можна скопіювати будь-яке з перевірених поєднань:</p>
        `
      },
      {
        type: 'table',
        headers: ['Настрій', 'Фон (Background)', 'Кнопка (Button)', 'Текст (Text)'],
        rows: [
          [
            'Фірмовий лайм (як марафон)',
            '<span class="swatch" style="background:#D5F174"></span><code>#D5F174</code>',
            '<span class="swatch" style="background:#8668FF"></span><code>#8668FF</code>',
            '<span class="swatch" style="background:#000000"></span><code>#000000</code>'
          ],
          [
            'Спокійний пісочний',
            '<span class="swatch" style="background:#E7DFCC"></span><code>#E7DFCC</code>',
            '<span class="swatch" style="background:#FF6C39"></span><code>#FF6C39</code>',
            '<span class="swatch" style="background:#000000"></span><code>#000000</code>'
          ],
          [
            'Терміново / розпродаж',
            '<span class="swatch" style="background:#FF6C39"></span><code>#FF6C39</code>',
            '<span class="swatch" style="background:#000000"></span><code>#000000</code> (текст білий)',
            '<span class="swatch" style="background:#FFFFFF"></span><code>#FFFFFF</code>'
          ]
        ]
      },
      {
        type: 'text',
        html: `
          <p class="note">Порада: темний текст на світлому фоні читається найкраще.
          Якщо залишити поля кольорів порожніми — підставляться стандартні
          (лайм для смуг, пісочний для промо).</p>
        `
      }
    ]
  },
  {
    id: 'targeting',
    title: 'Кому показувати',
    blocks: [
      {
        type: 'text',
        html: `
          <ul>
            <li><span class="field">Courses порожнє</span> → банер бачать
              <b>усі студенти на всіх сторінках</b>. Так запускають загальні новини.</li>
            <li><span class="field">Обрано курс(и)</span> → банер бачать лише студенти цих курсів:
              на головній сторінці курсу — завжди, всередині уроків — якщо ввімкнено
              <span class="field">Show on lessons</span>.</li>
            <li><span class="field">Country</span> → якій країні показувати.</li>
          </ul>
          <p><b>Приклад:</b> марафонський банер = курс «Марафон…» + Show on lessons увімкнено →
          студент бачить його і на сторінці курсу, і в кожному уроці,
          а студенти інших курсів — ніколи.</p>
        `
      }
    ]
  },
  {
    id: 'schedule',
    title: 'Коли показувати',
    blocks: [
      {
        type: 'text',
        html: `
          <ul>
            <li><span class="field">Start at</span> — дата й час появи. Порожньо = одразу.
              <b>Приклад:</b> прогрів стартує в понеділок о 9:00 — ставите
              <code>2026-09-28 09:00</code> у пʼятницю і йдете на вихідні: банер увімкнеться сам.</li>
            <li><span class="field">Auto-disable in (minutes)</span> — через скільки хвилин
              вимкнутись самому. <b>Шпаргалка:</b> 60 = година · 1440 = доба ·
              10080 = тиждень (це максимум). <b>Приклад:</b> плашка про техроботи на 2 години =
              <code>120</code> — і не треба памʼятати про неї вночі.</li>
            <li>Порожні обидва = працює, доки ви самі не вимкнете (Status → Disabled).</li>
          </ul>
        `
      }
    ]
  },
  {
    id: 'images',
    title: 'Картинки для Footer banner',
    blocks: [
      {
        type: 'text',
        html: `
          <ul>
            <li>Два файли: <b>для компʼютерів 1600×85</b> (довга стрічка) і
              <b>для телефонів 460×82</b> (компактна). Формати svg/png/jpg, кожен до 1 Mb.
              Обидва замовляйте в дизайнера одразу парою.</li>
            <li>Завантаження — <b>після першого Save</b>: створіть запис, відкрийте його знову —
              зʼявляться кнопки завантаження. Це не помилка, так задумано.</li>
            <li>Поки завантажена не вся пара — банер студентам <b>не показується</b>
              (щоб ніхто не побачив «половину» кампанії).</li>
            <li>Є тільки широка картинка? Позначте
              <span class="field">«Mobile banner not needed»</span> — банер працюватиме лише
              на компʼютерах, на телефонах його не буде.</li>
          </ul>
        `
      }
    ]
  },
  {
    id: 'dismiss',
    title: 'Хрестик: що буде після закриття',
    blocks: [
      {
        type: 'text',
        html: `
          <p><span class="field">Closable</span> вмикає хрестик.
          <span class="field">Dismiss scope</span> визначає, чи повернеться банер до студента,
          який його закрив:</p>
        `
      },
      {
        type: 'table',
        headers: ['Режим', 'Простими словами', 'Коли доречний'],
        rows: [
          [
            '<b>Every visit</b>',
            'повернеться при наступному заході на сторінку',
            'гарячі промо, короткі кампанії (так поводився старий банер)'
          ],
          [
            '<b>Session</b>',
            'не турбує до закриття вкладки браузера',
            'розумний вибір за замовчуванням'
          ],
          [
            '<b>Day</b>',
            'повернеться через добу',
            'мʼякі нагадування'
          ],
          [
            '<b>Forever</b>',
            'закрив — більше ніколи не побачить',
            'разові оголошення'
          ]
        ]
      },
      {
        type: 'warning',
        text: `Якщо студент уже закрив банер «назавжди», зміна режиму в цьому записі його
          не поверне — память про закриття лишається у студента в браузері.
          Треба перепоказати кампанію всім? Створіть новий запис віджета
          (можна з тими самими текстами й картинками) — у нового запису память закриттів чиста.`
      }
    ]
  },
  {
    id: 'troubleshooting',
    title: 'Щось пішло не так?',
    blocks: [
      {
        type: 'table',
        headers: ['Симптом', 'Найчастіша причина'],
        rows: [
          [
            'Зберіг, а банера у студентів немає',
            'Перевірте по черзі: Status = Active? Для Footer banner — чи завантажені <b>обидві</b> картинки (або стоїть «Mobile banner not needed»)? Start at не в майбутньому? Обрано саме той курс?'
          ],
          [
            '«Це поле обовʼязкове» при збереженні',
            'У кожного типу свій мінімум: Top bar — текст; Footer banner — посилання; Footer promo — текст + текст кнопки + посилання; Generic — текст (і посилання, якщо є кнопка).'
          ],
          [
            'Не зберігається імʼя',
            'Name має бути унікальним — таке імʼя вже зайняте іншим записом.'
          ],
          [
            'Немає кнопок завантаження картинок',
            'Спершу Save — кнопки зʼявляються у збереженому записі (див. розділ 7).'
          ],
          [
            'Я закрив банер і не бачу його при перевірці',
            'Ви ж і закрили 🙂 Відкрийте сторінку в режимі інкогніто — там банер буде.'
          ]
        ]
      }
    ]
  }
]
